export default __webpack_public_path__ + "static/media/cl-18.d2e9b59f.png";